import React from 'react'

import Image from 'next/image'

type Props = {
  nbMarque: number
  folder: string
  width: number
  height: number
}
const DisplayLogoBrands: React.FC<Props> = ({ nbMarque, folder, width, height }) => {
  const marques = []
  for (let i = 0; i < nbMarque; i += 1) {
    marques.push(
      <Image
        key={i}
        className="bg-no-repeat bg-contain bg-center object-contain"
        src={`${folder}${i}.png`}
        height={height}
        width={width}
        alt={`${i}`}
      />
    )
  }
  return <div className="flex flex-row flex-wrap justify-around sm:justify-center items-center w-full mb-8">{marques}</div>
}

export default DisplayLogoBrands
